import { AnvaPossiblePackage } from '@flows/src/types/anva';
import React, { FC } from 'react';
import { HStack, VStack, Text, Radio } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  selectedPackageCode: string | null;
  onPackageSelect: (packageCode: string) => void;
  packageOptions: AnvaPossiblePackage[];
}

const AnvaAddToPackageModalContent: FC<Props> = ({
  selectedPackageCode,
  onPackageSelect,
  packageOptions,
}) => {
  const { t } = useTranslation();

  return (
    <VStack align="stretch" spacing="2">
      {packageOptions.map((pkg) => {
        const isSelected = selectedPackageCode === pkg.code;
        return (
          <HStack
            key={pkg.code}
            p="3"
            border="1px"
            borderColor={isSelected ? 'primary.500' : 'gray.100'}
            borderRadius="md"
            onClick={() => onPackageSelect(pkg.code)}
            cursor="pointer"
            _hover={{ borderColor: 'primary.500' }}
            alignItems="flex-start"
            transition="0.2s"
          >
            <Radio
              isChecked={isSelected}
              borderColor="gray.200"
              onChange={() => onPackageSelect(pkg.code)}
              mt="0.5"
            />
            <VStack align="stretch" spacing="1">
              <Text textStyle="normalBodyMedium">{pkg.name}</Text>
              <Text
                textStyle="smallBody"
                color="gray.500"
                dangerouslySetInnerHTML={{
                  __html:
                    pkg.aantal_polissen_pakketkorting > 1
                      ? t('FLOW_PRODUCTS_BASKET_PACKAGE_AMOUNT-OF-INSURANCES', {
                          x: pkg.aantal_polissen_pakketkorting,
                        })
                      : t(
                          'FLOW_PRODUCTS_BASKET_PACKAGE_AMOUNT-OF-INSURANCES_SINGULAR',
                          {
                            x: pkg.aantal_polissen_pakketkorting,
                          },
                        ),
                }}
              />
            </VStack>
            <Text textStyle="h5Headline" ml="auto">
              -{pkg.pakketkorting_percentage}%
            </Text>
          </HStack>
        );
      })}
    </VStack>
  );
};

export default AnvaAddToPackageModalContent;
